import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-signin',
  templateUrl: './tutorial-signin.component.html',
  styleUrls: ['./tutorial-signin.component.css']
})
export class TutorialSigninComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
